import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const DiseaseCodeForm = (props) => {
    const initialFormData = {
        code: "",
        description: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    const formRef = useRef(null);

    useEffect(() => {
        if (props.insprvalue && props.insprvalue.id) {
            const { code, description, is_active, id } = props.insprvalue;
            setFormData({
                code: code || "",
                description: description || "",
                isactive: is_active == 1 || is_active === true,
                id: id || ""
            });
            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        } else {
            setFormData(initialFormData);
            setButtonStatus(mapYourMedsConstant.ADD_ACTION);
        }
    }, [props.edittrigger, props.insprvalue]);

    const isAddMode = buttonStatus === "Add" || buttonStatus === mapYourMedsConstant.ADD_ACTION;

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsUrl = isAddMode
            ? `${process.env.REACT_APP_SERVER_URL}/patients/add-patient-icd`
            : `${process.env.REACT_APP_SERVER_URL}/patients/update-patient-icd`;

        let pelmedsData = isAddMode
            ? {
                "code": formData.code,
                "description": formData.description,
                "group_id": localStorage.getItem("groupId") || '',
                "is_active": 1
            }
            : {
                "code": formData.code,
                "description": formData.description,
                "group_id": localStorage.getItem("groupId") || '',
                "is_active": formData.isactive ? 1 : 0,
                "id": formData.id
            };

        try {
            const { data } = await axios.post(pelmedsUrl, pelmedsData, {
                headers: { 'Authorization': `Bearer ${tokenStr}` }
            });

            if (data.status) {
                toast.success("Diagnosis added/updated successfully");
            } else {
                toast.info("Error while adding Diagnosis");
            }
        } catch (err) {
            toast.error("Error submitting Diagnosis");
        }

        setFormData(initialFormData);
        if (formRef.current) formRef.current.reset();
        setButtonStatus(mapYourMedsConstant.ADD_ACTION);

        if (props.onCallParent) props.onCallParent();
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Code</Form.Label>
                        <Form.Control
                            placeholder='Diagnosis Code (e.g. E11.9)'
                            value={formData.code}
                            name="code"
                            size="sm"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Description</Form.Label>
                        <Form.Control
                            placeholder='Description'
                            value={formData.description}
                            name="description"
                            size="sm"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group className="mb-3">
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={isAddMode ? true : formData.isactive}
                            disabled={isAddMode}
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className="d-flex justify-content-end">
                    <Button
                        type="submit"
                        variant="primary"
                        size="sm"
                        disabled={!formData.code || !formData.description}
                    >
                        {buttonStatus}
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export default DiseaseCodeForm;


